import React from "react";
import "@/App.css";
import Header from "@/components/landing/Header";
import HeroSection from "@/components/landing/HeroSection";
import HowItWorks from "@/components/landing/HowItWorks";
import Benefits from "@/components/landing/Benefits";
import StoryPreview from "@/components/landing/StoryPreview";
import SocialProof from "@/components/landing/SocialProof";
import GiftingSection from "@/components/landing/GiftingSection";
import FAQ from "@/components/landing/FAQ";
import Footer from "@/components/landing/Footer";
import FloatingWhatsApp from "@/components/landing/FloatingWhatsApp";
import StickyMobileCTA from "@/components/landing/StickyMobileCTA";

function App() {
  return (
    <div className="App">
      <Header />
      <main>
        <HeroSection />
        <HowItWorks />
        <Benefits />
        <StoryPreview />
        <SocialProof />
        <GiftingSection />
        <FAQ />
      </main>
      <Footer />
      <FloatingWhatsApp />
      <StickyMobileCTA />
    </div>
  );
}

export default App;
